export const GenericConstants = {
	MILEAGE_SEPARATOR: "'",
	DECIMAL_SEPARATOR: ",",
	NUM_OF_DECIMALS: 2,
	DEF_CURRENCY: "EUR"
};

export const HeaderKey = {
	NO_SUCCESS_POPUP: "X-No-Success-Popup",
	NO_ERROR_POPUP: "X-No-Error-Popup",
	NO_POPUP: "X-No-Popup",
	NO_SPIN: "X-No-Spin",
	TECH_INFO: "Tech-Info",
	TECH_INFO_BE: "BE-Tech-Info",
	WARNING: "X-Warning"
};

export const CustomRegExp = {
	MAX_100_CHAR: /^.{1,100}$/,
	MAX_500_CHAR: /^.{1,500}$/,
	CHAR_5: /^.{5}$/,
	CHAR_6: /^.{6}$/,
	CHAR_17: /^.{0,17}$/,
	MAX_3_INPUT: /^.{0,3}$/,
	MAX_8_CHAR: /^.{0,8}$/,
	MAX_9_INPUT: /^.{0,9}$/,
	NUMERIC_REGEXP: /^-?\d+$/,
	ALPHANUMERIC_REGEXP: /^[\wÀ-ÿ\d ]*$/,
	EMAIL_REGEXP:
		/^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	PERCENTAGE_2INT_2DEC: /^-?\d{1,2}([\.,]\d{1,2})?$/,
	PERCENTAGE: /^-?\d{1,2}([\.,]\d{1,3})?$/,
	PERCENTAGE_POSITIVE: /^\d{1,2}([\.,]\d{1,3})?$|^100$/,
	PERCENTAGE_2INT_3DEC: /^-?\d{1,2}([\.,]\d{1,3})?$/,
	PERCENTAGE_2INT_4DEC: /^-?\d{1,2}([\.,]\d{1,4})?$/,
	PERCENTAGE_3INT: /^-?\d{1,3}([\.,]\d{1,3})?$/,
	PERCENTAGE_3INT_4DEC: /^-?\d{1,3}([\.,]\d{1,4})?$/,
	PERCENTAGE_1DEC: /^-?\d{1,2}([\.,]\d)?$/,
	PERCENTAGE_2DEC: /^-?\d{1,6}([\.,]\d{1,2})?$/,
	PERCENTAGE_4DEC: /^-?\d{1,2}([\.,]\d{1,4})?$/,
	PERCENTAGE_6INT_4DEC: /^-?\d{1,6}([\.,]\d{1,4})?$/,
	PERCENTAGE_MAX_100: /^-?\d{1,2}([\.,]\d{1,3})?$|^100$/,
	PERCENTAGE_MAX_100_4DEC: /^-?\d{1,2}([\.,]\d{1,4})?$|^100$/,
	MAX_8_INT: /^-?\d{0,8}$/,
	MAX_6_INT: /^-?\d{0,6}$/,
	MAX_4_INT: /^-?\d{0,4}$/,
	MAX_3_INT: /^-?\d{0,3}$/,
	MAX_2_INT: /^-?\d{0,2}$/,
	MAX_2_INT_MIN_1: /^([1-9]|\d{2})$/,
	MAX_7CIFRE_DEC: /^-?\d{0,7}([\.,]\d{1,2})?$/,
	MAX_5CIFRE_DEC: /^-?\d{0,5}([\.,]\d{1,2})?$/,
	MAX_9CIFRE_DEC: /^-?\d{0,9}([\.,]\d{1,2})?$/,
	MAX_12CIFRE_DEC: /^-?\d{0,12}([\.,]\d{1,2})?$/,
	MAX_2CIFRE_DEC: /^-?\d{0,2}([\.,]\d{1,2})?$/,
	DATE: /^((\d{1,2}.\d{1,2}.\d{2,4})|(\d{2,4}.\d{1,2}.\d{1,2}))$/,
	EVERYTHING: /^.*$/
};

export const TimerInterval = {
	PROPOSAL_RELOAD: 3e4,
	SPINNER_FORCE_HIDING: 6e4
};

export const Market = {
	MARKET_EN: "EN",
	MARKET_IT: "IT",
	MARKET_DE: "DE",
	MARKET_NL: "NL",
	MARKET_ES: "ES",
	MARKET_BE: "BE",
	MARKET_FR: "FR",
	MARKET_LU: "LU",
	MARKET_OTHER: "OTHER"
} as const;

export const Markets = ["EN", "IT", "DE", "NL", "ES", "BE", "FR", "LU", "OTHER"];

export const SessionKey = {
	MARKET: "market",
	READONLY_USER: "readOnlyUser",
	USER_MARKET: "userMarket",
	USER_ID: "idUser",
	DEALER_ID: "idDealer",
	USER_TOKEN: "token",
	USER_LANGUAGE: "language",
	USER_PROFILE: "userProfile",
	USER_LOGOUT: "logout",
	TECH_INFO: "Tech-Info",
	TECH_INFO_BE: "BE-Tech-Info",
	PUSH_NOTIFICATION_TOKEN: "pushNotificationToken",
	DEALER_SEARCH: "dealerSearch",
	VEHICLE_SEARCH: "vehicleSearch",
	AUCTION_MANAGEMENT_SEARCH: "auctionManagementSearch",
	TEMPLATE_SEARCH: "templateSearch",
	VEHICLE_LIST: "vehicleList",
	OFFER_DETAIL: "offerDetail",
	LOT_DETAIL: "lotDetail",
	VEHICLE_LIST_DATATABLE: "vehicleListDataTable",
	GEOLOCATION_MARKET: "geolocationMarket",
	HAVE_PARTNER: "partners",
	/** Open accordions in desktop auction-details and live-item for multiple-car lots */
	OPEN_CAR_LOT_ACCORDIONS: "openCarAccordions",
	/** Open accordion in mobile auction-details for multiple-car lots */
	OPEN_CAR_LOT_ACCORDION_MOBILE: "openCarAccordionMobile",
	/** Open lot detail in mobile live-item */
	OPEN_LIVE_LOT_MOBILE: "openCarAccordionMobile",
	/** Tells whether user has selected a specific view on auction-details page */
	AUCTION_DETAIL_LISTVIEW: "auctionDetailListView",
	PURCHASE_HISTORY_SORTBY: "purchaseSortBy",
	PURCHASE_HISTORY_SORT_ORDER: "purchaseSortOrder",
	PURCHASE_HISTORY_PAGING: "purchasePaging",
	AUCTIONS_PAGING: "auctionSinglePaging",
	AUCTIONS_SINGLE_SORTBY: "auctionSingleSortBy",
	AUCTIONS_SINGLE_SORT_ORDER: "auctionSingleSortOrder",
	AUCTIONS_MULTI_SORTBY: "auctionMultiSortBy",
	AUCTIONS_MULTI_SORT_ORDER: "auctionMultiSorOrder",
	FILTERS_CONFIG: "filtersConfig"
} as const;

export const Role = {
	USER: "USER",
	ADMIN: "ADMIN",
	CUSTOMER_CENTER: "CUSTOMER_CENTER"
};

export const LotStatus = {
	AWARDED: "AWA",
	NOT_AWARDED: "NAW",
	TO_BE_AWARDED: "TBA"
};

export const ExportType = {
	CSV: "CSV",
	EXCEL: "XLSX"
};

export const AuctionStatus = {
	SCHEDULED: "SCH",
	RUNNING: "RUN",
	CLOSED: "CLD",
	AWARDED: "AWA"
} as const;

export type AuctionStatusType =
	(typeof AuctionStatus)[keyof typeof AuctionStatus];

export const AuctionType = {
	LEASYS: "LEA",
	MULTI: "MUL",
	OTHER: "OTH"
} as const;
export type AuctionTypeType =
	(typeof AuctionType)[keyof typeof AuctionType];

export const VehicleShowcaseState = {
	BOOKED: "CURRENT",
	PREEMPTION: "PREEMPTION",
	AVAILABLE: "MUL",
	NOT_AVAILABE: "OTH"
};

export const Channel = {
	SHOWCASE: "SHOWCASE",
	AUCTION: "AUCTION"
} as const;

export type ChannelType =
	(typeof Channel)[keyof typeof Channel];

export const LotType = {
	SUP: 0,
	STOCK: 1
};

export const ReportType = {
	LOGIN: "LOGIN",
	AUCTION: "AUCTION",
	OFFER: "OFFER"
};

export const PwdRecoveryMode = {
	EMAIL: "EMAIL",
	USERNAME: "USERNAME"
};

export enum Permission {
	AUCTIONEER = "AUCTIONEER",
	MULTI_AUCTIONEER = "MULTI_AUCTIONEER",
	LOADER = "LOADER",
	EXHIBITOR = "EXHIBITOR",
	BUYER = "BUYER",
	VISITOR = "VISITOR"
}

export const ClickarPath = {
	ADMIN: "admin",
	COOKIE: "cookie",
	FORBIDDEN: "forbidden",
	GENERIC: "**",
	HOME_PATH: "",
	PARTNER: "partner",
	REGISTRATION: "registration",
	PRIVACY: "privacy",
	PASSWORD_RECOVERY: "password-recovery",
	CHANGE_PASSWORD: "change-password",
	CHANGE_PASSWORD_LOGGED: "change-password",
	MY_LEASYS: "my-leasys",
	PRIVATE: "private",
	SUPPORT: "support",
	PURCHASE_SUMMARY: "purchase-summary",
	USER_PROFILE: "user-profile",
	USER_ANONYMIZATION: "user-anonymization",
	AUCTIONEER_MANAGEMENT: "auctioneer-management",
	CREATE_AUCTIONEER: "create-auctioneer",
	EDIT_AUCTIONEER: "edit-auctioneer",
	DEALER_MANAGEMENT: "dealer-management",
	SELLER_MANAGEMENT: "seller-management",
	AUCTIONEER: "auctioneer",
	DEALER: "dealer",
	DEALER_CONFIGURE: "dealer-configure",
	DEALER_LIST: "dealer-list",
	SELLER: "seller",
	SELLER_LIST: "seller-list",
	DEALER_SEARCH: "dealer-search",
	PUSH_NOTIFICATION: "push-notification",
	EMAIL: "email",
	LEAD: "lead",
	EXHIBITORS: "exhibitors",
	USERS: "users",
	USER_SIGNUP: "user-signup",
	BOOKLET: "booklet",
	TEMPLATE: "template",
	AUCTION_MANAGEMENT: "auction-management",
	CREATE_TEMPLATE: "create-template",
	CREATE_AUCTION: "create-auction",
	VEHICLE_MANAGEMENT: "vehicle-management",
	UPLOAD_VEHICLE: "upload-vehicle",
	VEHICLE_LIST: "vehicle-list",
	VEHICLE_DETAILS: "vehicle-details",
	VEHICLE_EDIT: "vehicle-edit",
	AUCTION_DETAILS: "auction-details",
	AUCTION: "auction",
	OFFER_MANAGEMENT: "offer-management",
	BUYER: "buyer",
	LOT_DETAIL: "lot-detail",
	LOGIN_MOBILE: "login-mobile",
	USER_TEMPLATE: "user-template",
	CREATE_SHOWCASE: "create-showcase",
	SHOWCASE_MANAGEMENT: "showcase-management",
	CREATE_SELLER: "create-seller",
	SHOWCASE_CATALOGUE: "showcase-catalogue",
	SHOWCASE_SOLD: "showcase-sold",
	LIVE_FULL: "live",
	MY_LOT: "my-lot",
	REPORT: "report",
	PRIVATE_COOKIE: "private-cookie",
	PRIVATE_PRIVACY: "private-privacy",
	PRIVATE_CONTACT: "private-contact",
	TERMS_AND_CONDITIONS: "terms-and-conditions",
	LEGAL_NOTES: "legal-notes",
	ACCESSIBILITY: "accessibility",
	USER_EDIT: "user-edit",
	USER_SHOWCASE: "user-showcase",
	COMPANY: "company",
	WHY_SIGN_UP_COMPONENT: "why-sign-up-component",
	CONTACT: "contact",
	PAYMENT_SUCCESS: "paymentSuccess",
	PAYMENT_FAILURE: "paymentError",
	SERVER_MAINTENANCE: "maintenance",
	OFFER_DETAIL: "offer-detail",
	ES: "es",
	BE: "be",
	HOMEPAGE_CUSTOM: "hp",
	IT: "it",
	EN: "en",
	DE: "de",
	NL: "nl",
	FR: "fr",
	PL: "pl",
	PT: "pt",
	LU: "lu"
} as const;